var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.75,
    height: 27,
    viewBox: "0 0 33.75 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-alt",
    "data-name": "Icon awesome-car-alt",
    d: "M30.843,14.929l-.79-1.976-1.4-3.5A7.837,7.837,0,0,0,21.34,4.5H12.41A7.837,7.837,0,0,0,5.1,9.45l-1.4,3.5-.79,1.976A4.49,4.49,0,0,0,0,19.125V22.5a4.463,4.463,0,0,0,1.125,2.948v3.8a2.25,2.25,0,0,0,2.25,2.25h2.25a2.25,2.25,0,0,0,2.25-2.25V27h18v2.25a2.25,2.25,0,0,0,2.25,2.25h2.25a2.25,2.25,0,0,0,2.25-2.25v-3.8A4.461,4.461,0,0,0,33.75,22.5V19.125A4.49,4.49,0,0,0,30.843,14.929ZM9.276,11.121A3.375,3.375,0,0,1,12.41,9h8.93a3.375,3.375,0,0,1,3.134,2.121l1.4,3.5h-18l1.4-3.5ZM5.625,22.486a2.122,2.122,0,0,1-2.25-2.243A2.122,2.122,0,0,1,5.625,18C6.975,18,9,20.019,9,21.364S6.975,22.486,5.625,22.486Zm22.5,0c-1.35,0-3.375.224-3.375-1.121S26.775,18,28.125,18a2.122,2.122,0,0,1,2.25,2.243,2.122,2.122,0,0,1-2.25,2.243Z",
    transform: "translate(0 -4.5)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/CarIcon.6b63051c7275d7e3c8a86e5dd89533f4.svg";
export { ForwardRef as ReactComponent };